import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75f047c6")

_pushScopeId("data-v-75f047c6")
const _hoisted_1 = { class: "login_bottom_action" }
const _hoisted_2 = {
  key: 0,
  class: "bottom_title flex_centers"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 微信扫码 ")
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 即可 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, " 登录/注册", -1)
const _hoisted_7 = {
  key: 1,
  class: "bottom_subtitle"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 和 ")
const _hoisted_10 = {
  key: 2,
  class: "login_bottom_subtitle"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "登录即同意", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.tabIdx === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          (!_ctx.isAiImageEditor)
            ? (_openBlock(), _createBlock("span", _hoisted_4, " 关注公众号 "))
            : _createCommentVNode("", true),
          _hoisted_5,
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabIdx === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("span", null, [
            _hoisted_8,
            _createVNode("span", {
              class: "common_bottom_subtitle_link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openUserProtocol && _ctx.openUserProtocol(...args)))
            }, "《用户协议》"),
            _hoisted_9,
            _createVNode("span", {
              class: "common_bottom_subtitle_link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openPrivacyPolicy && _ctx.openPrivacyPolicy(...args)))
            }, "《隐私政策》")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabIdx === 1)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", {
            class: "login_bottom_subtitle_link",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openMemberProtocol && _ctx.openMemberProtocol(...args)))
          }, "《会员服务使用协议》")
        ]))
      : _createCommentVNode("", true)
  ]))
})